import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Expert } from './expert.model'
import { BehaviorSubject } from 'rxjs';
import { TicketService } from '../customer/ticket/ticket.service';
import { LoginService } from '../user-login/login.service';
@Injectable({
  providedIn: 'root'
})
export class ExpertService {

  noAuthHeader = { headers: new HttpHeaders({ 'NoAuth': 'True' }) };

  ticketSource = new BehaviorSubject({});
  currentTicket = this.ticketSource.asObservable();

  constructor(private loginService : LoginService,private http: HttpClient) { }

  postExpert(expert: Expert){
 //console.log('Inside post expert', expert);
  return this.http.post(environment.apiBaseUrl+ '/moderator/signup', expert);
  }

  getAllTickets() {
    return this.http.get(environment.apiBaseUrl + '/techExpert/get-all-tickets')
  }

  getAllTransactions() {
    return this.http.get(environment.apiBaseUrl + '/techExpert/get-all-transactions')
  }

  changeTicket(ticket){
    this.ticketSource.next(ticket)
  }

  replyToTicket(ticketCred,fileToUpload){
    console.log(fileToUpload)
    const formData =new FormData()
    ticketCred.uploaderId="papa";
    formData.append('data',JSON.stringify(ticketCred))

    if(fileToUpload)
      formData.append('file',fileToUpload)

    formData.forEach((value,key) => {
      console.log(key+" "+value)
    });

    const req =this.http.post<any>(environment.apiBaseUrl + '/techExpert/reply-to-ticket', formData)
    console.log(req)
    return req;
  }

  getAllAttachments(ticketID) {
    return this.http.post<any>(environment.apiBaseUrl + '/techExpert/get-all-attachments',ticketID)
  }

  getCurrentBalance(){
    return this.http.get(environment.apiBaseUrl + '/techExpert/get-current-balance')
  }

  getAllUnpaidTransaction(){
    return this.http.get(environment.apiBaseUrl + '/techExpert/get-all-unpaid-transaction')
  }

  getAllPaidTransaction(){
    return this.http.get(environment.apiBaseUrl + '/techExpert/get-all-paid-transaction')
  }

  async sendTicketsRaisedDateRange(customerID, startDate, endDate) {
    try {
      let x = {
        customerId: customerID,
        startDate: startDate,
        endDate: endDate
      }
      let returnedBody = await fetch(environment.apiBaseUrl + '/moderator/get-tickets-raised-date-range', {
        method: 'POST',
        body: JSON.stringify(x),
        headers: {
          'Content-type': 'application/json; charset=UTF-8'
        }
      });
      console.log(returnedBody);

      return returnedBody;
    } catch (err) {
      console.log('error', err)
    }
  }

  async sendInvoiceDateFilter(expertId, startDate, endDate,fullName,mailingAddress){
    try {
        let x = {
          expertId: expertId,
          startDate: startDate,
          endDate: endDate,
          fullName : fullName,
          mailingAddress : mailingAddress
        }
        let returnedBody = await fetch(environment.apiBaseUrl+ '/techExpert/send-invoice', {
          method: 'POST',
          body: JSON.stringify(x),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Authorization': "Bearer " + this.loginService.getToken()
          }
        });
       //console.log(returnedBody);

        return returnedBody;
    } catch (err) {
     //console.log('error', err)
    }
    }

}


